import React from 'react';
import { Table } from 'react-bootstrap';
import Web3 from 'web3';

const ProposalTable = ({ proposals }) => {

  function singleProposal(proposal) {
    if (proposal[0] == "0") {
      return (
        <tr>

        </tr>
      )
    } else {
      return (
        <tr>
          <td>{proposal[0]}</td>
          <td>{parseInt(proposal[1]) == 1 ? "Yes" : "No"}</td>
          <td>{proposal[6]}</td>
          <td>{proposal[4]}</td>
          <td>{Web3.utils.fromWei(proposal[3], "ether")} ETH</td>
          <td>{proposal[8]}</td>
        </tr>
      );
    }
  };

  return (
    <Table bordered hover variant="light">
      <thead>
        <tr>
          <th>Proposal ID</th>
          <th>Is this an Admin Proposal?</th>
          <th>Proposing Address</th>
          <th>Category</th>
          <th>Spend Amount</th>
          <th>Receiving Address</th>
        </tr>
      </thead>
      <tbody>
        {proposals?.map(singleProposal)}
      </tbody>
    </Table>
  )


}

export default ProposalTable;
